import logo from "../../Images/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useScrollToTop } from "../../Utility";
import { useFormik } from "formik";
import { loginFormSchema } from "../../Schemas/LoginPage";
import { generateLoginRequest } from "../../features/Api/loginSlice";
import { getTokensFromLocalStorage } from "../../Utility/AccessAndRefreshTokenStorage";
import { setUserLogin } from "../../features/UserLoginStatusSlice";
import { setLoadingBarProgress } from "../../features/LoadingBarSlice";
import { useEffect } from "react";
import { setDefaultProfileState } from "../../features/Api/userProfile";

export default function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // * At the top of the page.
  useScrollToTop();

  const userProfileInfoError = useSelector(
    (state) => state.userProfileInfo
  ).error;

  // * Dispatch action's for reset all client data from redux
  useEffect(() => {
    dispatch(setDefaultProfileState());
  }, [userProfileInfoError, dispatch]);

  // * Start ***Enable Dark Mode Feature***
  const bgCardDynamic = useSelector((state) => state.setMode).css
    ?.cardBackground;
  const textColorDynamic = useSelector((state) => state.setMode).css?.textColor;
  const textFormAlertLightMode = useSelector((state) => state.setMode).css
    ?.textFormAlertColor;

  // * Handel form
  const logInRequest = useSelector((state) => state.logIn);
  const initialValues = {
    email: "",
    password: "",
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues: initialValues,
      validationSchema: loginFormSchema,
      onSubmit: (values) => {
        dispatch(generateLoginRequest(values));
        dispatch(setLoadingBarProgress({ progress: 70 }));
      },
    });

  const { logIn } = getTokensFromLocalStorage();
  if (logIn === true) {
    if (logInRequest?.success) {
      dispatch(setUserLogin());
      navigate("/account/dashboard");
      dispatch(setLoadingBarProgress({ progress: 100 }));
    }
  }
  if (logIn === false) {
    if (logInRequest?.error) {
      dispatch(setLoadingBarProgress({ progress: 100 }));
    }
  }

  return (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8 mt-16">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          <img
            className="mx-auto h-16 w-auto rounded-lg shadow-lg"
            loading="lazy"
            src={logo}
            alt="Company logo"
          />
          <h2 className="mt-3 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            Log-in in to your account
          </h2>
        </div>
        <div className=" mt-4">
          <h5 className=" text-Brand-Color  font-extrabold text-center block  underline">
            Welcome to jsonOnClouds
          </h5>
        </div>
        <div
          className={`${bgCardDynamic} mt-2 sm:mx-auto sm:w-full sm:max-w-sm  pb-12 pt-6  px-6 rounded-xl  shadow-2xl`}
        >
          <form
            onSubmit={handleSubmit}
            className="space-y-6"
            action="POST"
            method="POST"
          >
            <div>
              <label
                htmlFor="email"
                className="block text-sm text-Brand-Color  leading-6 text-white/90 font-extrabold"
              >
                Email address
              </label>
              <div className="mt-2">
                <input
                  onClick={() => dispatch(setDefaultProfileState())}
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  className="block px-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ffa200d7] outline-none sm:text-sm sm:leading-6"
                />
                {errors.email && touched.email ? (
                  <small
                    className={`${textFormAlertLightMode} text-xs font-semibold`}
                  >
                    {errors.email}
                  </small>
                ) : (
                  <></>
                )}
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <label
                  htmlFor="password"
                  className="block text-sm text-Brand-Color  leading-6 text-white/90 font-extrabold"
                >
                  Password
                </label>
                <div className="text-sm">
                  <Link
                    to="/forgot-password"
                    className="font-semibold text-Brand-Color hover:text-Brand-Color-Light transition delay-150 duration-300 ease-in-out"
                  >
                    Forgot password?
                  </Link>
                </div>
              </div>
              <div className="mt-2">
                <input
                  onClick={() => dispatch(setDefaultProfileState())}
                  id="password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  required
                  className="block px-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-[#ffa200d7] outline-none sm:text-sm sm:leading-6"
                />
                {errors.password && touched.password ? (
                  <small
                    className={`${textFormAlertLightMode} text-xs font-semibold`}
                  >
                    {errors.password}
                  </small>
                ) : (
                  <></>
                )}
                {!logInRequest?.success && logInRequest.error ? (
                  <small
                    className={`${textFormAlertLightMode} text-xs font-semibold`}
                  >
                    {logInRequest?.error?.msg}
                  </small>
                ) : (
                  <small
                    className={`${textFormAlertLightMode} text-xs font-semibold bg-transparent text-transparent`}
                  >
                    Transparent
                  </small>
                )}
              </div>
            </div>

            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-Brand-Color hover:bg-Brand-Color-Light  px-3 py-1.5 text-sm  leading-6 text-white font-bold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#ffa200e8]"
              >
                {logInRequest?.loading ? "Loading..." : "Log-in"}
              </button>
            </div>
          </form>

          <p className={`mt-10 text-center text-sm ${textColorDynamic}`}>
            You Can not have an account?{" "}
            <Link
              to="/signup"
              className="font-semibold leading-6 text-Brand-Color hover:text-Brand-Color-Light"
            >
              Sing-up Now
            </Link>
          </p>
        </div>
      </div>
    </>
  );
}
